import styled from 'styled-components';

export const AboutLinkSection = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 3em 1em;
  display: grid;
  grid-template-columns: 400px 1fr;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const LinksSection = styled.div`
  display: flex;
  align-items: flex-start;

  @media (max-width: 720px) {
    flex-wrap: wrap;
  }
`;

export const AccordionTabs = styled.div`
  overflow: hidden;
  flex-grow: 1;
  @media (max-width: 720px) {
    flex-basis: 100%;
  }
`;

export const TabsItem = styled.div`
  width: 100%;
  color: white;
  overflow: hidden;
  border-right: 1px solid #00000018;
  position: relative;

  @media (max-width: 720px) {
    border-right: none;
    border-bottom: 1px solid #00000018;
  }

  label {
    display: flex;
    padding: 0 1em;
    color: #000000c7;
    font-weight: bold;
    position: relative;

    @media (max-width: 720px) {
      justify-content: space-between;
      cursor: default;
      padding: 10px 1em;
      display: flex;
      align-items: center;
    }

    &::after {
      @media (max-width: 720px) {
        content: '+';
        width: 40px;
        text-align: center;
        transition: all 0.35s;
        font-size: 25px;
        font-weight: 500;
        color: #000000a8;
      }
    }
  }
  .tab-content {
    max-height: 100vh;
    padding: 0 1em;
    color: black;
    transition: all 0.35s ease;
    display: flex;

    @media (max-width: 720px) {
      max-height: 0;
      justify-content: flex-start;
    }
  }
`;

export const InputField = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;

  &:checked {
    + .tab-label {
      &::after {
        @media (max-width: 720px) {
          content: '-';
          font-size: 25px;
          font-weight: 500;
          color: #0000004a;
        }
      }
    }

    ~ .tab-content {
      max-height: 100vh;
      padding-bottom: 8px;
    }
  }
`;

export const TabList = styled.a`
  font-size: 13px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.8);
  padding: 18px 0 0;
  cursor: pointer;
  display: block;

  &:hover {
    color: #0000007d;
  }
  @media (max-width: 720px) {
    cursor: default;
    padding: 8px 0;
  }
`;

export const AboutUs = styled.div`
  padding-bottom: 6px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
  font-weight: 600;
`;

export const TrustedLine = styled.div`
  width: 65%;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
  padding: 12px 0 0;

  @media (max-width: 720px) {
    width: 100%;
    padding: 16px 0px;
  }
  .list {
    list-style: none;
    li {
      margin: 16px 0;
    }
  }
`;

export const MyloDescription = styled.div`
  @media (max-width: 720px) {
    padding: 0 12px;
  }
`;

export const PlayStorebtn = styled.div`
  padding: 10px 0;
  display: flex;
  column-gap: 16px;

  @media (max-width: 720px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const PlayStoreImagesSvg = styled.span`
  svg {
    width: 90px;
    height: auto;
    transition:
      transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
      box-shadow 0.3s ease 0s;
    &:hover {
      transform: scale(1.04);
    }
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
`;
export const PlayStoreImages = styled.img`
  width: 90px;
  height: auto;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  &:hover {
    transform: scale(1.04);
  }
  @media (min-width: 720px) {
    cursor: pointer;
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;

export const LogoBg = styled.div`
  // background: #fff;
  border-radius: 12px;
  display: inline;
  padding: 6px 0px 0 0;
  margin: 8px 0;
  svg {
    width: 50px;
    height: auto;
  }
`;
